import { db, storage } from './firebase';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

// User API

export const doCreateUser = (id, username, email) =>
  db.ref(`users/${id}`).set({
    username,
    email,
  });

// Conversation API

export const doCreateRoom = (myId, buddyId) => {
  let members = {};
  members[myId] = true;
  members[buddyId] = true;
  const snap = db.ref('rooms').push({
    members
  });
  const roomKey = snap.ref.key;
  let newRoom = {};
  newRoom[roomKey] = {
    members: [buddyId],
    lastUpdated: 0 - parseInt(moment().format('X'), 10),
  };
  db.ref(`users/${myId}/rooms`).update(newRoom);
  newRoom[roomKey].members = [myId];
  db.ref(`users/${buddyId}/rooms`).update(newRoom);

  return roomKey;
};

export const doDeleteRoom = (userId, roomId) => {
  db.ref(`users/${userId}/hiddenRooms`)
    .push(roomId);
};

export const getHiddenRooms = (userId) => {
  return db.ref(`users/${userId}/hiddenRooms`);
};

export const fixUserChatRooms = (userId) => {
  db.ref(`users/${userId}/rooms`).once('value')
    .then(snap => {
      const rooms = snap.val();
      if(rooms !== null) {
        Object.keys(rooms).map(key => {
          const roomKey = Object.keys(rooms[key]);
          if (roomKey.length === 1) {
            const roomMembers = rooms[key][roomKey];
            let newRoom = {};
            newRoom[roomKey] = {
              members: roomMembers,
              lastUpdated: 0 - parseInt(moment().format('X'), 10),
            };
            db.ref(`users/${userId}/rooms`).update(newRoom);
            db.ref(`users/${userId}/rooms/${key}`).remove();
          }
          return key;
        });
      }
    });
};

export const listUsersRoom = (id) =>
  db.ref(`users/${id}/rooms`);

export const markUnread = (roomId, userId) => {
  const ref = db.ref(`users/${userId}/unread`);
  ref.once('value')
    .then(snap => {
      let value = {};
      if(snap.val() !== null) {
        value = snap.val();
      }
      value[roomId] = true;
      ref.set(value);
    });
};

export const userUnread = userId => {
  let ref = db.ref(`users/${userId}/unread`);
  ref.once('value')
    .then(snapshot => {
      if(snapshot.val() != null) {
        const roomKey = Object.keys(snapshot.val())[0];
        db.ref(`rooms/${roomKey}`)
          .once('value')
          .then(snap => {
            if (snap.val() == null) {
              db.ref(`users/${userId}/unread/${roomKey}`).remove();
            }
          });
      }
    });
  return ref;
};

export const markAllRead = (roomId, userId) => {
  db.ref(`users/${userId}/unread`).child(roomId).remove();
};

export const deleteUserRooms = (userId) => {
  return new Promise((resolve) => {
    db.ref(`users/${userId}/rooms`).once('value')
      .then(snap => {
        snap.forEach(room => {
          db.ref(`users/${room.val().members[0]}/rooms/${room.key}`).remove();
          db.ref(`users/${room.val().members[0]}/unread/${room.key}`).remove();
          db.ref(`users/${room.val().members[1]}/unread/${room.key}`).remove();
          db.ref(`users/${userId}`).remove();
          db.ref(`rooms/${room.key}`).remove();
          resolve();
        });
      });
  });
};

export const getRoomMembers = (id) =>
  db.ref(`rooms/${id}/members`).once('value');

export const getUsername = (id) =>
  db.ref(`users/${id}/username`).once('value');

export const doSendMessage = (roomId, sender, buddyId, content, photo, time) => {
  markUnread(roomId, buddyId);
  if(isEmpty(photo)) {
    db.ref(`rooms/${roomId}/messages`).push({
      content,
      type: 'text',
      senderId: sender.name,
      time,
    });
  } else {
    db.ref(`rooms/${roomId}/messages`).push({
      content: 'photo',
      type: 'photo',
      senderId: sender.name,
      time,
    }).then(data => {
        storage.ref(`${roomId}/${data.key}/image`).putString(photo.src, 'data_url')
          .then(upload => {
            const imgUrl = storage.ref(upload.metadata.fullPath).toString();
            photo.src = imgUrl;
            data.update({content: photo})
          });
      });
  }

  db.ref(`users/${sender.id}/rooms/${roomId}`).update({lastUpdated: 0 - parseInt(moment().format('X'), 10)});
  db.ref(`users/${buddyId}/rooms/${roomId}`).update({lastUpdated: 0 - parseInt(moment().format('X'), 10)});

  db.ref(`users/${buddyId}/hiddenRooms/`).once('value')
    .then(snap => {
      if(snap.val() !== null) {
        snap.forEach(child => {
          if(child.val() === roomId) {
            db.ref(`users/${buddyId}/hiddenRooms/${child.key}`).remove();
          }
        });
      }
    });

  db.ref(`users/${sender.id}/hiddenRooms/`).once('value')
    .then(snap => {
      if(snap.val() !== null) {
        snap.forEach(child => {
          if(child.val() === roomId) {
            db.ref(`users/${sender.id}/hiddenRooms/${child.key}`).remove();
          }
        });
      }
    });
};

export const getRef = (ref) =>
  db.ref(ref);

export const getRoomMessages = (roomId) =>
  db.ref(`rooms/${roomId}/messages`);



// WEBPACK FOOTER //
// ./src/firebase/db.js